// src/components/SimpleComponents/SimpleSegment.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Segmented } from 'antd';
import SimpleFormItem from './SimpleFormItem';
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  IssuesCloseOutlined,
} from '@ant-design/icons';
import useFormElement from 'hooks/useFormElement';
import { useSimpleFormContext } from './SimpleFormProvider';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// FUNCTIONS
// *******************************************************************************
function $buildOptions() {
  return [
    { value: 1, label: 'Option 1', icon: <IssuesCloseOutlined /> },
    {
      value: 2,
      label: 'Option 2 (disabled)',
      icon: <ExclamationCircleOutlined />,
      disabled: true,
    },
    { value: 3, label: 'Option 3', icon: <CheckCircleOutlined /> },
  ];
}

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleSegment = ({
  name,
  subdocumentField,
  options = $buildOptions(),
  block = true,
  onChange,
  disabled,
  size,
  value, // controlled value - when provided, overrides form value for instant visual feedback
  ...props
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { locked, disabledFields } = useSimpleFormContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const elementProps = useFormElement(name, subdocumentField);
  const { elementRef, fullFieldName, flattenFieldName } = elementProps;

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const isDisabled = disabled || locked || disabledFields?.includes(flattenFieldName);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <SimpleFormItem {...props} name={fullFieldName} elementProps={elementProps}>
      <Segmented
        ref={elementRef}
        id={flattenFieldName}
        options={options}
        block={block}
        onChange={onChange}
        disabled={isDisabled}
        size={size}
        {...(value !== undefined && { value })}
      />
    </SimpleFormItem>
  );
};

export default SimpleSegment;
